import React, {useState} from "react";
import {InputText} from "primereact/inputtext";
import {InputTextarea} from "primereact/inputtextarea";
import {Dropdown} from "primereact/dropdown";
import {InputSwitch} from "primereact/inputswitch";
import {AutoComplete} from "primereact/autocomplete";
import {getFromHub} from "../../../network/actions";

export function TextFormField(props) {
    return (
        <>
            <label> {props.label}
                {props.readOnly &&
                <div>
                    {props.value || "/"}
                </div>
                }

                {!props.readOnly &&
                <InputText className="block w-full"
                           value={props.value}
                           onChange={(e) => props.updateFormState({[props.name]: e.target.value})}/>
                }
            </label>
        </>
    );
}

export function MultiLangText(props) {
    return (
        <>
            <label> {props.label}
                <InputText className="block w-full"
                           value={props.value.values.en}
                           onChange={(e) => props.updateFormState({[props.name]: {values: {en: e.target.value}}})}/>
            </label>
        </>
    );
}

export function TextareaFormField(props) {
    return (
        <>
            <label className="block" htmlFor={props.name}> {props.label}</label>
            <InputTextarea id={props.name}
                           className="block w-full"
                           value={props.value}
                           onChange={(e) => props.updateFormState({[props.name]: e.target.value})} />
        </>
    );
}

export function DropdownBasicFormField(props) {
    return (
        <>
            <label className="block" htmlFor={props.name}> {props.label}</label>
            <Dropdown
                inputId={props.name}
                value={props.value.id}
                options={parseOptions(props.type, props.options)}
                onChange={(e) => props.updateFormState({[props.name]: {id: e.target.value}})}
                placeholder="Please select"
                className="w-full"/>

        </>
    );
}

export function DropdownEnumFormField(props) {
    return (
        <>
            <label className="block" htmlFor={props.name}> {props.label}</label>
            <Dropdown
                inputId={props.name}
                value={props.value}
                options={parseOptions(props.type, props.options)}
                onChange={(e) => props.updateFormState({[props.name]: e.target.value})}
                placeholder="Please select"
                className="w-full"/>
        </>
    );
}

export function SwitchFormField(props) {
    return (
        <>
            <label className="block" htmlFor={props.name}> {props.label}</label>
            <InputSwitch
                id={props.name}
                checked={props.value}
                onChange={(e) => props.updateFormState({[props.name]: e.value})}/>
        </>
    );
}

export function AutocompleteFormField(props) {
    const [suggestions, setSuggestions] = useState(null);

    return (
        <>
            <label className="block" htmlFor={props.name}> {props.label}</label>
            <AutoComplete dropdown={true}
                          minLength={props.minLength}
                          value={props.value}
                          field="name"
                          onChange={(e) => props.updateFormState({[props.name]: e.value})}
                          onSelect={(e) => {
                              props.updateFormState({...populateDependentFields(props.fields, e.value)})
                          }}
                          suggestions={suggestions}
                          completeMethod={(e) => {
                              getSuggestions(props.url + e.query, setSuggestions)
                          }}
                          className="w-full relative"/>

        </>
    );
}

export function NotImplementedFormField(props) {
    return (
        <div>
            {props.label} - TODO - handle this type: {props.type}
        </div>
    )
}

function populateDependentFields(fields, selectedValue) {
    const dependentFields = {};
    Object.keys(fields).forEach(fieldName => {
        dependentFields[fieldName] = selectedValue[fields[fieldName]];
    });

    return dependentFields;
}

async function getSuggestions(url, setter) {
    const results = await getFromHub(url, () => {}, () => {setter([{name: "error with fetching suggestions data"}])});
    setter(results);
}

function parseOptions(type, options) {
    switch (type) {
        case "dropdown-basic":
            return options.map(option => {
                return {label: option.name.defaultValue, value: option.id}
            });
        case "dropdown-enum":
            return options.map(option => {
                return {label: option.name, value: option.name}
            });
        default:
            return [{label: "Error - case not handled", value: 0}];
    }
}